module.exports = __webpack_public_path__ + "cy.a36cd09b89519c0e5c08.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cy.svg
// module chunks = styles